/** Shared column definitions for payment / return / shipment / allocation grids. */

export const ALLOCATION_TABLE_PAGE_SIZE = 500;

export const PAYMENT_CLIENT_COLUMNS = [
  { field: 'name', title: 'Client Name', widthClass: 'w-[11%]' },
  { field: 'clientNo', title: 'Client No', widthClass: 'w-[7%]' },
  { field: 'mobile', title: 'Client Mobile', widthClass: 'w-[9%]' },
  { field: 'location', title: 'Location', widthClass: 'w-[9%]' },
  { field: 'emirate', title: 'Emirate', widthClass: 'w-[8%]' },
  { field: 'area', title: 'Area', widthClass: 'w-[8%]' },
  { field: 'responsibleBy', title: 'Responsible By', widthClass: 'w-[10%]' },
  { field: 'payMode', title: 'Payment Mode', widthClass: 'w-[9%]', sortable: false, filterable: false },
  { field: 'totalOrders', title: 'Total Orders', widthClass: 'w-[7%]', align: 'right' },
  { field: 'totalAmount', title: 'Total Amount', widthClass: 'w-[8%]', align: 'right' },
  { field: 'totalPaying', title: 'Total Paying', widthClass: 'w-[8%]', align: 'right' },
  { field: 'actions', title: 'Options', widthClass: 'w-[6%]', sortable: false, filterable: false, groupable: false, align: 'center' },
];

export const PAYMENT_ORDER_MODAL_COLUMNS = [
  { field: 'voucher', title: 'Voucher No', widthClass: 'w-[8%]' },
  { field: 'deliveryDate', title: 'Delivery Date', widthClass: 'w-[7%]' },
  { field: 'customer', title: 'Customer', widthClass: 'w-[9%]' },
  { field: 'customerNo', title: 'Mobile No', widthClass: 'w-[7%]' },
  { field: 'locationEmirate', title: 'Location | Emirate', widthClass: 'w-[10%]' },
  { field: 'productCharge', title: 'Product Charge', widthClass: 'w-[7%]', align: 'right' },
  { field: 'serviceCharge', title: 'Service Charge', widthClass: 'w-[7%]', align: 'right' },
  { field: 'vat', title: 'VAT', widthClass: 'w-[5%]', align: 'right' },
  { field: 'clientMoney', title: 'Client Money', widthClass: 'w-[7%]', align: 'right' },
  { field: 'payType', title: 'Payment Type', widthClass: 'w-[7%]' },
  { field: 'advanceCharge', title: 'Advance Charge', widthClass: 'w-[6%]', align: 'center' },
  { field: 'advancePrice', title: 'Advance Price', widthClass: 'w-[6%]', align: 'center' },
  { field: 'free', title: 'Free', widthClass: 'w-[5%]', align: 'center' },
  { field: 'status', title: 'Status', widthClass: 'w-[7%]', sortable: false },
];

export const NEW_SHIPMENT_NOTE_COLUMNS = [
  { field: 'refNo', title: 'Ref No', widthClass: 'w-[10%]' },
  { field: 'date', title: 'Date', widthClass: 'w-[9%]' },
  { field: 'driver', title: 'Driver', widthClass: 'w-[14%]' },
  { field: 'vehicle', title: 'Vehicle', widthClass: 'w-[14%]' },
  { field: 'status', title: 'Status', widthClass: 'w-[10%]' },
  { field: 'remarks', title: 'Remarks', widthClass: 'w-[16%]' },
  { field: 'createdBy', title: 'Created By', widthClass: 'w-[12%]' },
  { field: 'actions', title: 'Options', widthClass: 'w-[10%]', sortable: false, filterable: false, groupable: false, align: 'center' },
];

export const CONVERT_SHIPMENT_COLUMNS = [
  {
    field: 'voucher',
    title: 'Voucher No',
    widthClass: 'w-[9%]',
    headerClassName:
      'sticky left-0 top-0 z-[40] border-r border-gray-200 bg-[#eef2f7] min-w-[10rem] max-w-[12rem] w-[10rem]',
  },
  {
    field: 'status',
    title: 'Status',
    widthClass: 'w-[8%]',
    headerClassName:
      'sticky left-[10rem] top-0 z-[40] border-r border-gray-200 bg-[#eef2f7] min-w-[8rem] w-[8rem] whitespace-nowrap',
  },
  { field: 'clientBill', title: 'Client Bill', widthClass: 'w-[7%]' },
  { field: 'deliveryDate', title: 'Delivery Date', widthClass: 'w-[8%]' },
  { field: 'client', title: 'Client', widthClass: 'w-[9%]' },
  { field: 'customer', title: 'Customer', widthClass: 'w-[9%]' },
  { field: 'customerArea', title: 'Customer Area', widthClass: 'w-[8%]' },
  { field: 'customerLocation', title: 'Customer Location', widthClass: 'w-[9%]' },
  { field: 'storeRef', title: 'Store Ref', widthClass: 'w-[7%]' },
  { field: 'productPrice', title: 'Product Price', widthClass: 'w-[7%]', align: 'right' },
  { field: 'deliveryCharge', title: 'Delivery Charge', widthClass: 'w-[7%]', align: 'right' },
  { field: 'tax', title: 'TAX', widthClass: 'w-[5%]', align: 'right' },
  { field: 'payType', title: 'Pay Type', widthClass: 'w-[6%]' },
  { field: 'customerAmount', title: 'Customer Amount', widthClass: 'w-[7%]', align: 'right' },
  { field: 'clientAmount', title: 'Client Amount', widthClass: 'w-[7%]', align: 'right' },
  { field: 'attempts', title: 'Attempts', widthClass: 'w-[6%]', align: 'right' },
  { field: 'quantity', title: 'Quantity', widthClass: 'w-[6%]', align: 'right' },
  { field: 'pickup', title: 'Pickup', widthClass: 'w-[6%]' },
];

const col = (field, title, widthClass, extra = {}) => ({ field, title, widthClass, hideable: true, ...extra });

export const deliveryPendingColumns = () => [
  col('voucher', 'Voucher No', 'w-[7%]'),
  col('client', 'Client', 'w-[8%]'),
  col('pickupDate', 'Pickup Date', 'w-[7%]'),
  col('deliveryDate', 'Delivery Date', 'w-[7%]'),
  col('customer', 'Customer', 'w-[9%]'),
  col('customerNo', 'Customer No', 'w-[7%]'),
  col('customerAddress', 'Customer Address', 'w-[11%]'),
  col('customerArea', 'Customer Area', 'w-[7%]'),
  col('customerLocation', 'Customer Location', 'w-[8%]'),
  col('status', 'Status', 'w-[8%]', { sortable: false }),
  col('amount', 'Amount', 'w-[6%]', { align: 'right' }),
  col('attempts', 'Attempts', 'w-[5%]', { align: 'right' }),
  col('remarks', 'Remarks', 'w-[7%]'),
  col('storeRef', 'Store #', 'w-[5%]'),
];

export const deliveryAllocatedColumns = (showNewStoreRef = false) => {
  const cols = [
    col('voucher', 'Voucher No', 'w-[7%]'),
    col('client', 'Client', 'w-[8%]'),
    col('pickupDate', 'Pickup Date', 'w-[7%]'),
    col('deliveryDate', 'Delivery Date', 'w-[7%]'),
    col('customer', 'Customer', 'w-[9%]'),
    col('customerNo', 'Customer No', 'w-[7%]'),
    col('customerAddress', 'Customer Address', 'w-[10%]'),
    col('customerArea', 'Customer Area', 'w-[7%]'),
    col('customerLocation', 'Customer Location', 'w-[8%]'),
    col('status', 'Status', 'w-[8%]', { sortable: false }),
    col('amount', 'Amount', 'w-[6%]', { align: 'right' }),
    col('attempts', 'Attempts', 'w-[5%]', { align: 'right' }),
    col('remarks', 'Remarks', 'w-[7%]'),
    col('storeRef', 'Store #', 'w-[5%]'),
  ];
  if (showNewStoreRef) {
    cols.push(col('newStoreRef', 'New Store #', 'w-[6%]', { sortable: false, filterable: false }));
  }
  cols.push({ field: 'actions', title: 'Options', widthClass: 'w-[5%]', sortable: false, filterable: false, groupable: false, align: 'center' });
  return cols;
};

export const pickupPendingColumns = () => [
  col('voucher', 'Voucher No', 'w-[7%]'),
  col('pickupDate', 'Pickup Date', 'w-[7%]'),
  col('deliveryDate', 'Delivery Date', 'w-[7%]'),
  col('client', 'Client', 'w-[9%]'),
  col('clientNo', 'Client No', 'w-[7%]'),
  col('clientAddress', 'Client Address', 'w-[11%]'),
  col('clientArea', 'Client Area', 'w-[7%]'),
  col('clientLocation', 'Client Location', 'w-[8%]'),
  col('status', 'Status', 'w-[8%]', { sortable: false }),
  col('amount', 'Amount', 'w-[6%]', { align: 'right' }),
  col('remarks', 'Remarks', 'w-[8%]'),
];

export const pickupAllocatedColumns = () => [
  ...pickupPendingColumns(),
  { field: 'actions', title: 'Options', widthClass: 'w-[5%]', sortable: false, filterable: false, groupable: false, align: 'center' },
];

export const formatDateCell = (dateString, formatter) => {
  if (!dateString) return '-';
  if (formatter) return formatter(dateString);
  try {
    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) return String(dateString);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return String(dateString);
  }
};

export const getPaymentClientCellValue = (client, field) => {
  switch (field) {
    case 'name': return client.Name || '-';
    case 'clientNo': return client.ClientNo ?? '-';
    case 'mobile': return client.MobileNo1 || '-';
    case 'location': return client.LocationName || '-';
    case 'emirate': return client.EmirateName || '-';
    case 'area': return client.AreaName || '-';
    case 'responsibleBy': return client.ResponsibleBy?.Name || '-';
    case 'payMode': return client.PayMode || 'CASH';
    case 'totalOrders': return client.TotalOrders ?? 0;
    case 'totalAmount': return client.TotalClientMoney ?? 0;
    case 'totalPaying': return client.TotalPayingMoney ?? 0;
    default: return client[field];
  }
};

export const getPaymentOrderCellValue = (order, field, formatCurrency) => {
  switch (field) {
    case 'voucher': return order.VoucherNo || '-';
    case 'clientBill': return order.ClientBillNo || '-';
    case 'pickupDate': return formatDateCell(order.PickupDate);
    case 'deliveryDate': return formatDateCell(order.DeliveryDate);
    case 'customer': return order.Customer?.Name || '-';
    case 'customerNo': return order.Customer?.MobileNo1 || '-';
    case 'locationEmirate': {
      const loc = order.CustomerAddress?.Location?.Name || '';
      const em = order.CustomerAddress?.Emirate?.Name || '';
      return [loc, em].filter(Boolean).join(' | ') || '-';
    }
    case 'productCharge': return formatCurrency ? formatCurrency(order.ProductPrice) : order.ProductPrice;
    case 'serviceCharge': return formatCurrency ? formatCurrency(order.DeliveryCharge) : order.DeliveryCharge;
    case 'advanceCharge': return formatCurrency ? formatCurrency(order.AdvanceCharge) : order.AdvanceCharge;
    case 'advancePrice': return formatCurrency ? formatCurrency(order.AdvancePrice) : order.AdvancePrice;
    case 'clientMoney': return formatCurrency ? formatCurrency(order.ClientAmount) : order.ClientAmount;
    case 'payType': return order.PayType || '-';
    case 'vat': return formatCurrency ? formatCurrency(order.TAX) : order.TAX;
    case 'advanceCharge': return order.IsAdvancePay ? 'Yes' : 'No';
    case 'advancePrice': return order.IsAdvancePrice ? 'Yes' : 'No';
    case 'free': return order.IsFree ? 'Yes' : 'No';
    case 'status': return order.Status?.Name || '-';
    default: return order[field];
  }
};

export const getNewShipmentNoteCellValue = (note, field, formatDate) => {
  switch (field) {
    case 'refNo': return note.RefNo || '-';
    case 'date': return formatDate ? formatDate(note.Date) : formatDateCell(note.Date);
    case 'driver': return note.Driver?.Name || '-';
    case 'vehicle':
      return note.Vehicle
        ? `${note.Vehicle.Number}${note.Vehicle.Model ? ` (${note.Vehicle.Model})` : ''}`
        : '-';
    case 'status': return note.Status || '-';
    case 'remarks': return note.Remarks || '-';
    case 'createdBy': return note.CreatedName || '-';
    default: return note[field];
  }
};

export const getConvertShipmentCellValue = (detail, field, formatDate) => {
  const order = detail.Order || {};
  switch (field) {
    case 'voucher': return order.VoucherNo || '-';
    case 'status': return detail.Status?.Name || '-';
    case 'clientBill': return order.ClientBillNo || '-';
    case 'deliveryDate': return formatDate ? formatDate(order.DeliveryDate) : formatDateCell(order.DeliveryDate);
    case 'client': return order.Client?.Name || '-';
    case 'customer': return order.Customer?.Name || '-';
    case 'customerArea': return order.CustomerAddress?.Location?.Area?.Name || '-';
    case 'customerLocation': return order.CustomerAddress?.Location?.Name || '-';
    case 'storeRef': return order.StoreRefNo ?? '-';
    case 'productPrice': return order.ProductPrice ?? '-';
    case 'deliveryCharge': return order.DeliveryCharge ?? '-';
    case 'tax': return order.TAX ?? '-';
    case 'payType': return order.PayType || '-';
    case 'customerAmount': return order.CustomerAmount ?? '-';
    case 'clientAmount': return order.ClientAmount ?? '-';
    case 'attempts': return order.Attempts ?? '-';
    case 'quantity': return order.Quantity ?? '-';
    case 'pickup': return order.IsPickup ? 'Yes' : 'No';
    default: return detail[field];
  }
};

export const getDeliveryOrderCellValue = (row, field, formatDateToString, mode = 'pending') => {
  const order = row.Order || row;
  const status = row.Status || order.Status || {};
  const customerAddress = order.CustomerAddress || {};
  const location = customerAddress.Location || {};
  const area = location.Area || {};
  switch (field) {
    case 'voucher': return order.VoucherNo || '-';
    case 'client': return order.Client?.Name || '-';
    case 'pickupDate': return order.PickupDate ? (formatDateToString ? formatDateToString(order.PickupDate) : formatDateCell(order.PickupDate)) : '-';
    case 'deliveryDate': return order.DeliveryDate ? (formatDateToString ? formatDateToString(order.DeliveryDate) : formatDateCell(order.DeliveryDate)) : '-';
    case 'customer': return order.Customer?.Name || '-';
    case 'customerNo': return order.Customer?.MobileNo1 || '-';
    case 'customerAddress': return customerAddress.Address || '-';
    case 'customerArea': return area.Name || '-';
    case 'customerLocation': return location.Name || '-';
    case 'status': return status.Name || '-';
    case 'amount': return order.CustomerAmount ?? '-';
    case 'attempts': return order.Attempts ?? '-';
    case 'remarks': return order.Remarks || '-';
    case 'storeRef': return order.StoreRefNo ?? '-';
    case 'newStoreRef': return order.StoreRefNo ?? '-';
    default: return order[field];
  }
};

export const getPickupOrderCellValue = (row, field, formatDateToString) => {
  const order = row.Order || row;
  const status = row.Status || order.Status || {};
  const clientAddress = order.ClientAddress || {};
  const location = clientAddress.Location || {};
  const area = location.Area || {};
  switch (field) {
    case 'voucher': return order.VoucherNo || '-';
    case 'pickupDate': return order.PickupDate ? (formatDateToString ? formatDateToString(order.PickupDate) : formatDateCell(order.PickupDate)) : '-';
    case 'deliveryDate': return order.DeliveryDate ? (formatDateToString ? formatDateToString(order.DeliveryDate) : formatDateCell(order.DeliveryDate)) : '-';
    case 'client': return order.Client?.Name || '-';
    case 'clientNo': return order.Client?.MobileNo1 || '-';
    case 'clientAddress': return clientAddress.Address || '-';
    case 'clientArea': return area.Name || '-';
    case 'clientLocation': return location.Name || '-';
    case 'status': return status.Name || '-';
    case 'amount': return order.ClientAmount ?? '-';
    case 'remarks': return order.Remarks || '-';
    default: return order[field];
  }
};
